import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import { financialProductRuleCommissionModalVar } from './variables';
import FinancialProductRulesEditDetailsCommissionsEditComponent from './FinancialProductRulesEditDetailsCommissionsEditComponent';

const FinancialProductRulesEditDetailsCommissionsModalComponent = () => {
  const financialProductRuleCommissionModal = useReactiveVar(financialProductRuleCommissionModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    financialProductRuleCommissionModalVar({ open: false });
  }, []);

  return (
    <Dialog open={financialProductRuleCommissionModal.open} maxWidth='sm' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{financialProductRuleCommissionModal.open && <FinancialProductRulesEditDetailsCommissionsEditComponent commission={financialProductRuleCommissionModal.item} />}</DialogContent>
    </Dialog>
  );
};

export default FinancialProductRulesEditDetailsCommissionsModalComponent;
